export default "__VITE_ASSET__BzjQiMlC__"